import React from "react"
import ReactDOM from "react-dom"
import ParkingSearch from "./parking-search-component"

export default class ParkingSearchModule {
  constructor(elem) {
    const self = this
    self.elem = elem
    self.modelJson = elem.dataset.modelJson && JSON.parse(elem.dataset.modelJson)
    self.locale = document.body && document.body.dataset.language
    this.init()
    return self
  }

  init() {
    const self = this
    ReactDOM.unmountComponentAtNode(self.elem)
    ReactDOM.render(<ParkingSearch {...self.modelJson} locale={self.locale} />, self.elem)
  }
}
